import React, { useState, useEffect } from 'react';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Typography, Button } from '@mui/material';
import { getApiHeader } from 'utlis/commonfunctions';
import { toZonedTime, toDate } from 'date-fns-tz';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import Loader from 'layouts/nbn/components/loader';
import { useNavigate, useLocation } from 'react-router-dom';

const SERVER_URL = process.env.REACT_APP_API_URL;


const ApproveDeviationRequest = () => {
  const [ruleName, setRuleName] = useState('Design agency');
  const [selectedDay, setSelectedDay] = useState('');
  const [selectedWeek, setSelectedWeek] = useState('');
  const [reviewers, setReviewers] = useState([]);
  const [weekRange, setWeekRange] = useState(null);
  const [loading, setLoading] = useState(false);
  const [workWeek, setWorkWeek] = useState('');
  const location = useLocation();

  const navigate = useNavigate();
  const { retailerId, workPlanId, startDate, endDate } = location.state || {};

  const handleViewDetails = (retailerId , workPlanId, startDate, endDate) => {
 
    navigate('/approve_deviation_request_edit', { state: { retailerId ,workPlanId, startDate, endDate} });
  };
  
  useEffect(() => {
    // If startDate and endDate are passed, calculate and set the week range
    if (startDate && endDate) {
      const weekRange = { start: startDate, end: endDate };

      const dayOfWeek = new Date(startDate).getDay();

      if (dayOfWeek === 0) { // If it's Sunday
          // Adjust the start and end dates by adding one day if it's Sunday
          const adjustedStartDate = new Date(startDate);
          adjustedStartDate.setDate(adjustedStartDate.getDate() + 1); // Add one day to start date
          weekRange.start = adjustedStartDate.toISOString().split('T')[0];

          const adjustedEndDate = new Date(endDate);
          adjustedEndDate.setDate(adjustedEndDate.getDate() + 1); // Add one day to end date
          weekRange.end = adjustedEndDate.toISOString().split('T')[0];
      }

      setWeekRange(weekRange);
      setSelectedWeek(JSON.stringify(weekRange)); // Set it as the selected week in the dropdown
      fetchReviewersData(weekRange.start, weekRange.end);
    }
  }, [startDate, endDate]);

  const fetchReviewersData = async (startDate, endDate) => {
    setLoading(true);
    const headers = await getApiHeader();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}work-plan/get-work-plan-deviation-request-list`, {
        work_week_start_date: startDate,
        work_week_end_date: endDate,
      }, { headers });
      
      setReviewers(response.data.data.work_plan_deviation_data);
    } catch (error) {
      console.error("API Error:", error);
      // Handle error (Toast, alert, etc.)
    } finally {
      setLoading(false);
    }
  };

  const handleWeekChange = async (e) => {
    const selectedValue = e.target.value;
    setReviewers([]);
    // First, check if the selected value is empty
    if (!selectedValue) {
        setSelectedWeek(null);
        setWorkWeek(null);
        setWeekRange(null);
         
        return; // Exit if no week is selected
    }

    // Attempt to parse the selected value
    let newWeekRange;
    try {
        newWeekRange = JSON.parse(selectedValue);
    } catch (error) {
        console.error("Invalid JSON format in selected option:", error);
        return; // Exit if the selected value is not valid JSON
    }

    const startDate = new Date(newWeekRange.start);
    const dayOfWeek = startDate.getDay();
 
    if (dayOfWeek === 0) {
 
        startDate.setDate(startDate.getDate() + 1);
        newWeekRange.start = startDate.toISOString().split('T')[0];
 
        const endDate = new Date(newWeekRange.end);
        endDate.setDate(endDate.getDate() + 1);
 
        newWeekRange.end = endDate.toISOString().split('T')[0];
    }

    setWeekRange(newWeekRange); // Store the new week range
    setSelectedWeek(selectedValue);
    setWorkWeek(selectedValue);
   // setSelectedWeek(JSON.stringify(newWeekRange));
   
    
    setLoading(true); // Start loading indicator

    const headers = await getApiHeader(); // Ensure getApiHeader() returns the right headers

    try {
        // Make the API request to fetch work plan creators
        const response = await axios.post(`${SERVER_URL}work-plan/get-work-plan-deviation-request-list`, {
          work_week_start_date: newWeekRange.start,
          work_week_end_date: newWeekRange.end,
        }, {
            headers: headers
        });

        setReviewers(response.data.data.work_plan_deviation_data);

    } catch (error) {
    
      if (error.response) {
        // The server responded with a status other than 2xx
        const statusCode = error.response.status;
        const errorMessage = error.response.data.message || 'An unexpected error occurred';
  
        // Example of handling specific error codes
        if (statusCode === 400) {

        //  toast.error(`Error ${errorMessage}`);
        //   swal({
        //     title: "Error",
        //     text: errorMessage,
        //     icon: "error",
        //     button: "Close",
        // });
        } else if (statusCode === 500) {
        //  toast.error(`Server Error: ${errorMessage}`);
        //   swal({
        //     title: "Error",
        //     text: errorMessage,
        //     icon: "error",
        //     button: "Close",
        // });
        } else {
        //  toast.error(`Error: ${errorMessage}`);
        //   swal({
        //     title: "Error",
        //     text: errorMessage,
        //     icon: "error",
        //     button: "Close",
        // });
        }

      } else if (error.request) {
        // The request was made but no response was received
        toast.error('No response from the server');
      } else {
        // Something else happened while setting up the request
        toast.error('Request setup error');
      }

    } finally {
        // Stop loading indicator after request finishes
        setLoading(false);
    }
};


const getWeekOptions = () => {
  const options = [];
  const currentDate = new Date();

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const localDate = toZonedTime(currentDate, timezone);

  const currentDay = localDate.getDay();
  const daysUntilMonday = currentDay === 0 ? -6 : 1 - currentDay; // Adjust to nearest Monday
  localDate.setDate(localDate.getDate() + daysUntilMonday);

  for (let i = 0; i < 4; i++) {
      const startOfWeek = new Date(localDate);
      startOfWeek.setDate(localDate.getDate() + i * 7);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 4); 

      const localStartOfWeek = toZonedTime(startOfWeek, timezone);
      const localEndOfWeek = toZonedTime(endOfWeek, timezone);

      const weekLabel = `${localStartOfWeek.toLocaleString('default', { month: 'short' })} ${localStartOfWeek.getDate()} - ${localEndOfWeek.toLocaleString('default', { month: 'short' })} ${localEndOfWeek.getDate()}`;

      // const weekRange = {
      //     start: toDate(startOfWeek).toISOString().split('T')[0],
      //     end: toDate(endOfWeek).toISOString().split('T')[0] 
      // };

        const weekRange = {
            start: localStartOfWeek.toLocaleDateString('en-CA'),
            end: localEndOfWeek.toLocaleDateString('en-CA')
      };

      options.push(
          <option key={i} value={JSON.stringify(weekRange)}>
              {weekLabel}
          </option>
      );
  }

  return options;
};



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="container workplanform p-3">
        <Typography variant="h4" gutterBottom><h4>Approve/Reject deviation request</h4> </Typography>

   
          <div className="form-group">
          <>
            <label htmlFor="work-week" className="label">Select the Work Week:</label>
            <select id="work-week" name="work-week" className="select" onChange={handleWeekChange} value={selectedWeek}>
                <option value="">Please choose an option</option>
                {getWeekOptions()}
            </select></>
          </div>
     

        <Typography variant="body2" color="textSecondary" gutterBottom>
          Please review deviation requests and approve or reject. 
        </Typography>
  

        {loading ? (
          <div className="text-center">
              <Loader />  {/* You can replace this with a spinner component */}
          </div>
        ) : (
        <div className="table-responsive mt-3">
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Sl No</th>
              <th>PID</th>
              <th>Created Date</th>
              <th>Retailer Name</th>
              <th>Status</th>
              <th>Verified By</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {reviewers.length > 0 ? reviewers.map((reviewer, index) => (
              <tr key={reviewer.creator_id}> {/* Use retailer_id as the unique key */}
                <td>{index + 1}</td> {/* Sl No (index + 1) */}
                <td>{reviewer.retailer_code}</td> {/* PID */}
                <td>{ reviewer.date} </td>
                <td>{ reviewer.retailer_name} </td>
                <td>
                    {reviewer.status === 1 ? 'Approved' :
                     reviewer.status === 2 ? 'Rejected' : 
                     'Pending'}
                </td>
                <td>
                    {reviewer.verified_by == "admin" ? reviewer.admin_user : 
                        reviewer.verified_by == "manager" ? reviewer.manager_name : "Not Verified"}
                   ({reviewer.verified_by})
                </td>
                <td>
                      {reviewer.status === 0 && (
                        <button
                          className="btn btn-danger btn-sm ms-2" style={{ backgroundColor: '#e20e75' }}
                          onClick={() => handleViewDetails(reviewer.creator_id,reviewer.work_plan_deviation_id, weekRange?.start, weekRange?.end)}
                        >
                          View Plans Details
                        </button>
                      )}
                    </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="8" className="text-center">No work plan deviations found for the selected week</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

)}
      </div>
    </DashboardLayout>
  );
};

export default ApproveDeviationRequest;
